// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TWgNs","rootNoMargin":"styles_rootNoMargin__1vYCC"};